export default {
  en: {
    messages: {
      short_link: () => "Entered shortlink contains special symbols or spaces",
    },
  },
};
